import gql from 'graphql-tag';
import { useQuery } from 'urql';

import { GameDescriptor } from '@/fragments/GameDescriptor';
import { useQueryParams } from '@/hooks';
import { assert } from '@/utils/error';
import {
  PlayerGameRoundInspectionQuery,
  PlayerGameRoundInspectionQueryVariables,
} from './__generated__/usePlayerGameRound';
import { queryParams } from './queryParams';

const PLAYER_GAME_ROUNDS_QUERY = gql`
  query PlayerGameRoundInspection($playerId: ID!, $gameRoundId: String!) {
    player(playerId: $playerId) {
      id
      gameRounds(gameRoundId: $gameRoundId) {
        edges {
          node {
            brand {
              id
              name
            }
            currency
            gameId
            gameRoundId
            gameProvider
            startedAt
            completedAt
            totalBets
            totalWins
            totalJackpotContribution
            totalJackpotPayout
            openingBalance
            closingBalance
            status
            gameDescriptor: gameDescriptorV2 {
              ...GameDescriptor
            }
          }
        }
      }
    }
  }
  ${GameDescriptor}
`;

export default function usePlayerGameRound(playerId: string) {
  const [query] = useQueryParams(queryParams);

  assert(query.gameRoundId, 'missing gameRoundId');

  const [{ data, fetching }, refresh] = useQuery<
    PlayerGameRoundInspectionQuery,
    PlayerGameRoundInspectionQueryVariables
  >({
    query: PLAYER_GAME_ROUNDS_QUERY,
    variables: {
      playerId,
      gameRoundId: query.gameRoundId,
    },
  });

  return {
    refresh,
    fetching,
    gameRound: data?.player.gameRounds?.edges?.map((edge) => edge?.node)[0],
  };
}
